import { render, staticRenderFns } from "./WelcomeWord.vue?vue&type=template&id=7954cbb0&scoped=true&"
import script from "./WelcomeWord.vue?vue&type=script&lang=js&"
export * from "./WelcomeWord.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeWord.vue?vue&type=style&index=0&id=7954cbb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7954cbb0",
  null
  
)

export default component.exports